import Vue from 'vue'

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

import App from './App.vue'
import './assets/css/styles.css'
import './config/loading'
import router from './config/router'
import store from './config/store'
import './plugins/axios'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

import { registerLicense, L10n, setCulture } from '@syncfusion/ej2-base'
import ptBR from '@syncfusion/ej2-locale/src/pt-BR.json'
registerLicense(process.env.VUE_APP_SYNCFUSION_KEY)
L10n.load(ptBR)
setCulture('pt-BR')

import { DocumentEditorContainerPlugin } from '@syncfusion/ej2-vue-documenteditor'
Vue.use(DocumentEditorContainerPlugin) 

import '@syncfusion/ej2-base/styles/material.css'
import '@syncfusion/ej2-buttons/styles/material.css'
import '@syncfusion/ej2-inputs/styles/material.css'
import '@syncfusion/ej2-popups/styles/material.css'
import '@syncfusion/ej2-navigations/styles/material.css'
import '@syncfusion/ej2-splitbuttons/styles/material.css'
import '@syncfusion/ej2-layouts/styles/material.css'
import '@syncfusion/ej2-lists/styles/material.css'
import '@syncfusion/ej2-dropdowns/styles/material.css'
import '@syncfusion/ej2-documenteditor/styles/material.css'
import '@syncfusion/ej2-pdfviewer/styles/material.css'

Vue.use(VuePlyr, {
    plyr: {
        controls: [
            'play', 'progress', 'current-time', 'duration',
            'mute', 'volume', 'settings', 'pip', 'airplay', 'fullscreen'
        ],
        ratio: '16:9',
        clickToPlay: true,
        fullscreen: { enabled: true, iosNative: true }
    }
})

import VueHtmlToPaper from 'vue-html-to-paper'
const options = {
    name: '_blank',
    specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
    styles: ['https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css'],
    timeout: 1000,
    autoClose: true,
    windowTitle: window.document.title,
}
Vue.use(VueHtmlToPaper, options)

Vue.config.productionTip = true
Vue.config.errorHandler = function (err, vm, info) {
    console.log(`Error: ${err.toString()}\nInfo: ${info}`)
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
